import { createTheme } from "@mui/material/styles";

/**
 * Global source sants typography theme.
 */
export const SourceSansTypography = createTheme({
  typography: {
    fontFamily: '"Source Sans 3", sans-serif',
  },
});
